export const myAppointmentsPath = (token, fromId) => {
  let query = `token=${token}`;
  if (fromId) {
    query += `&fromId=${fromId}`;
  }

  return `/myappointments?${query}`;
};
